import {Component, OnInit} from '@angular/core';
import {Login} from "../../models/login";
import {LoginService} from "../../services/login.service";
import {Router} from "@angular/router";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {ValidatorService} from "../../core/services/validator.service";
import {Usuario} from "../../models/usuario";
import {UsuarioService} from "../../services/usuario.service";
import {NgxSpinnerService} from "ngx-spinner";
import {MessageService} from "../../core/services/message.service";
import {NavBarComponent} from "../../core/components/nav-bar/nav-bar.component";
import {Perfil} from "../../models/perfil";

@Component({
	selector: 'app-perfil',
	templateUrl: './perfil.component.html',
	styleUrls: ['./perfil.component.scss']
})
export class PerfilComponent implements OnInit {

	private usuario: Usuario;
	public form: FormGroup;
	public possui_permissao: boolean = true;

	constructor(private loadingService: NgxSpinnerService, private messageService: MessageService, private loginService: LoginService, private router: Router, private usuarioService: UsuarioService) {

	}

	ngOnInit() {
		let login: Login = this.loginService.getAuth();
		if(login){
			if(login.perfil == Perfil.GESTOR){
				this.possui_permissao = false;
			}
		}else{
			this.router.navigateByUrl("/login");
		}
		this.loadingService.show();
		this.form = new FormGroup({
			txt_nome: new FormControl(null, [
				Validators.required,
			]),
			num_cpf: new FormControl(null, [
				Validators.required,
				ValidatorService.cpf
			]),
			num_telefone: new FormControl(null, [
				Validators.required,
				ValidatorService.telefone
			]),
			txt_cargo: new FormControl(null, [
				Validators.required
			]),
			txt_email: new FormControl(null, [
				Validators.required,
				Validators.email,
			]),
			txt_orgao: new FormControl(null, [
				Validators.required
			]),
			txt_unidade: new FormControl(null, [
				Validators.required
			]),
			txt_senha: new FormControl(null, [

			]),
			txt_confirmar_senha: new FormControl(null, [

			])
		});
		this.usuarioService.findByToken().subscribe((usuario: any) => {
			this.loadingService.hide();
			this.usuario = usuario;
			this.form.patchValue({
				txt_nome: this.usuario.txt_nome,
				num_cpf: this.usuario.num_cpf,
				num_telefone: this.usuario.num_telefone,
				txt_cargo: this.usuario.txt_cargo,
				txt_email: this.usuario.txt_email,
				txt_orgao: this.usuario.txt_orgao,
				txt_unidade: this.usuario.txt_unidade
			});
		}, () => {
			this.loadingService.hide();
		});
	}

	save(): void{
		this.form.markAsTouched();
		if(this.form.valid) {
			let errors: Array<string> = [];
			let form = this.form.value as Usuario;
			let senha_informada: boolean = false;
			if (form.txt_senha && form.txt_confirmar_senha) {
				form.txt_senha = btoa(form.txt_senha);
				form.txt_confirmar_senha = btoa(form.txt_confirmar_senha);
				senha_informada = true;
			} else {
				delete form.txt_senha;
				delete form.txt_confirmar_senha;
			}
			if(!this.possui_permissao){
				let senha: string = form.txt_senha;
				let confirmar_senha: string = form.txt_confirmar_senha;
				form = this.usuario;
				form.txt_senha = senha;
				form.txt_confirmar_senha = confirmar_senha;
				if(!senha_informada){
					errors.push("Seu perfil só pode alterar a senha, informe-a");
				}
			}
			if(errors.length == 0) {
				this.loadingService.show();
				this.usuarioService.update(form).subscribe((data: any) => {
					let login: Login = this.loginService.getAuth();
					login.txt_nome = form.txt_nome;
					login.txt_email = form.txt_email;
					login.num_cpf = form.num_cpf;
					login.num_telefone = form.num_telefone;
					login.txt_cargo = form.txt_cargo;
					this.loginService.setSession(login);
					NavBarComponent.login = login;
					this.loadingService.hide();
					this.messageService.showSuccess("Alteração realizada com sucesso");
				}, (error) => {
					this.loadingService.hide();
					this.messageService.showResponseError(error);
				});
			}else{
				errors.forEach((error: string) => {
					this.messageService.showError(error);
				});
			}
		}
	}

}
